export default __webpack_public_path__ + "static/media/r3.bb8fc6ac.jpeg";